import head from 'lodash/head';
import { parseDomain, ParseResultType } from 'parse-domain';
import { HANDLE_SUBDOMAIN } from 'constants';
import { getActiveBrand } from 'services/active_brand';

export const getCurrentSubDomain = () => {
  if (!HANDLE_SUBDOMAIN) {
    return getActiveBrand();
  }
  const parseResult = parseDomain(window.location.host);
  let subDomain = null;

  switch (parseResult.type) {
    case ParseResultType.Invalid: {
      if (parseResult.hostname.includes('localhost:5002')) {
        subDomain = head(parseResult.hostname.split('.'));
      }
      break;
    }
    case ParseResultType.Listed: {
      subDomain = head(parseResult.subDomains);
      break;
    }
    case ParseResultType.Reserved: {
      if (parseResult.labels.length > 2) {
        subDomain = head(parseResult.labels);
      }
      break;
    }
    default:
      subDomain = null;
      break;
  }

  return subDomain;
};
